import { useState, useEffect } from 'react';
import { firestore, collection, addDoc, Timestamp } from './firebase-config';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
import SignUpForm from './SignUpForm';

function createSlug(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

const ADMIN_UIDS = ['1AO9qg3AtpUeJpnUJp5LDNcEnHM2', 'YOBAtkmQrdaJohjsOn0hOqeQFZ62'];

const AdminBlogEditor = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [author, setAuthor] = useState('');
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), setUser);
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const slug = createSlug(title);
    await addDoc(collection(firestore, 'blogPosts'), {
      title,
      slug,
      content,
      author,
      publishedAt: Timestamp.now(),
    });
    alert('Blog post added!');
    setTitle('');
    setContent('');
    setAuthor('');
  };

  const handleUserSignIn = (user) => {
    setUser(user);
  };

  if (!user) {
    return <SignUpForm onSignUpSuccess={handleUserSignIn} />;
  }

  if (!ADMIN_UIDS.includes(user.uid)) {
    return <p>Access denied. You are not authorized to view this page.</p>;
  }

  return (
    <div className="admin-editor">
      <h2>New Blog Post</h2>
      <form onSubmit={handleSubmit}>
        <input
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <input
          placeholder="Author"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          required
        />
        <textarea
          placeholder="Write your post here in HTML or Markdown"
          rows={10}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />
        <button type="submit">Publish</button>
      </form>
    </div>
  );
};

export default AdminBlogEditor;
